
export class SimpleFileDrop {




}